import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import { SetupWizardState } from '@mira-avant/mtlibs';

export const clientRequiredGuard: CanActivateFn = async (route, state) => {
	const router = inject(Router);
	const clientService = inject(ClientService);
	const authService = inject(AuthService);

	const isAdmin = await authService.isAdmin$();

	const clientUuidParam = route.paramMap.get('clientUuid');
	const stateParam = route.paramMap.get('state');

	if (!clientUuidParam || !stateParam) {
		console.error('Invalid URL segments for client-required guard');

		return router.createUrlTree(['/']);
	}

	// Validate state is valid
	if (!stateParam || !Object.values(SetupWizardState).includes(stateParam as SetupWizardState)) {
		console.error('Invalid state for client-required guard', stateParam);

		// Invalid state → fallback (or redirect to picker/dashboard)
		return router.createUrlTree(['my', 'admin', 'setup-wizard', SetupWizardState.CLIENT_PICKER]);
	}

	if (!clientUuidParam) {
		console.error('No client UUID in URL for client-required guard');

		// No client UUID in URL → redirect to client picker
		return router.createUrlTree(['my', 'admin', 'setup-wizard', SetupWizardState.CLIENT_PICKER]);
	}

	if (isAdmin) {
		// Admins can edit any client
		return true;
	} else {
		const client = await clientService.getClientBySubDomain$();

		// User is not an admin and there is no client specified, send to login.
		if (!client?.uuid) {
			console.error('No client found for subdomain');

			return router.createUrlTree(['/']);
		}

		// User is not an admin AND the selected client UUID in the URL is not theirs - try again.
		if (client.uuid !== clientUuidParam) {
			console.error("Selected client UUID does not match the user's client UUID", {
				selectedClientUuid: clientUuidParam,
				userClientUuid: client.uuid,
			});

			return router.createUrlTree(['my', 'admin', 'setup-wizard', SetupWizardState.CLIENT_PICKER]);
		}

		// User is not an admin AND the selected client matches the URL - ok.
		return true;
	}
};
